export default __webpack_public_path__ + "static/media/eco_img_02.6ca4421c.png";